export enum ShipmentOption {
    HAZARDOUS_MATERIALS = 'hazardous_materials',
    REFRIGERATED_TRUCK = 'refrigerated_truck',
    INSURANCE_CATEGORY = 'insurance_category',
}
